module.exports = __webpack_public_path__ + "static/img/zhayan.a99b7816.gif";